import { createSelector } from "reselect";

const DrawerOpenSelector = ({ ui }) => ui.navDrawerOpen;

export const getDrawerOpen = createSelector(
	[DrawerOpenSelector],
	(drawerOpen) => drawerOpen
);